export default "__VITE_ASSET__754257e8__"